module.exports = __webpack_public_path__ + "media/images/xpass/entry-loader-mobile-9cf65bb6daa0d86abeed2c516e4532e0.svg";